// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1IRyx","footer":"ModalError_footer__2w1_h"};